export default {"src":"/_next/static/media/solana.3244dbee.svg","height":40,"width":40};